export enum DefaultPathEnum {
  AUTH_SIGN_UP_SCREEN = '/auth/signup',
  AUTH_SIGN_IN_SCREEN = '/auth/signin',

  AUTH_FORGOT_PASSWORD = '/auth/forgot-password',
  AUTH_FORGOT_PASSWORD_VERIFY = '/auth/forgot-password/verify',
  AUTH_FORGOT_PASSWORD_RESET = '/auth/forgot-password/reset',

  ACCOUNTS_CREATE_PROFILE = '/accounts/create-profile',
  ACCOUNTS_BEGIN_JOURNEY = '/accounts/begin-journey',

  ACCOUNTS_MANAGE_PROFILE = '/accounts/manage-profile',

  HOME_SCREEN = '/learn',
  LEARN_SCREEN = '/learn/lesson',
  LEARN_LESSONS_COMPLETED_SCREEN = '/learn/lessons-completed',
}
